export const Monogram = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect x="1" y="1" width="38" height="38" rx="9" fill="#14110D" />
    <path
      d="M20 9 L13.5 30 M20 9 L26.5 30 M16 23.5 h8"
      stroke="#F4F1EA"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M30 15.5 a5.5 5.5 0 1 0 0 9"
      stroke="#C8402A"
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);
